import { fromJS } from 'immutable';
import { CHANGE_LOCALE, DEFAULT_LOCALE } from './actions';
import moment from 'moment';

const initialState = fromJS({
  locale: DEFAULT_LOCALE,
});

function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCALE:
      moment.locale(action.locale);
      return state.set('locale', action.locale);
    default:
      return state;
  }
}

export default languageProviderReducer;
